import React from "react";

export const Facebook = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <g clipPath="url(#clip0_778_178)">
        <path
          d="M28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 23.993 14.9255 27.3027 18.75 27.9028V22.3125H16.7188V20H18.75V18.2375C18.75 16.2325 19.9444 15.125 21.7717 15.125C22.6467 15.125 23.5625 15.2812 23.5625 15.2812V17.25H22.5538C21.56 17.25 21.25 17.8667 21.25 18.5V20H23.4688L23.1141 22.3125H21.25V27.9028C25.0745 27.3027 28 23.993 28 20Z"
          fill="#6C3BC7"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_778_178">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
